import { Link } from 'react-router-dom';
import { useReports } from '../hooks/useReports';

const HomePage = () => {
  const { reportIds } = useReports();

  return (
    <section id="landing-page" style={{ display: 'flex', flex: '1 1 auto', minHeight: 0, overflow: 'auto', padding: '1.2em 0.5em' }}>
      <div className="container-fluid h-100 d-flex flex-column" style={{ maxWidth: '1200px' }}>
        <h2 className="mb-3" style={{ fontWeight: 700, color: 'var(--text-primary)', fontSize: '1.5em' }}>Welcome to ADAP</h2>
        <div className="row mb-2 flex-grow-1">
          <div className="col-12 col-sm-6 col-lg-4 mb-3">
            <Link to="/genie" id="landing-genie-link" className="landing-tile landing-tile-genie d-flex flex-column align-items-center justify-content-center text-decoration-none h-100 w-100">
              <span className="landing-tile-icon mb-1"><i className="fa fa-wand-magic-sparkles"></i></span>
              <span className="landing-tile-title">Genie AI Assistant</span>
              <span className="landing-tile-desc">Ask questions about SME data using Genie.</span>
            </Link>
          </div>
          <div className="col-12 col-sm-6 col-lg-4 mb-3">
            <div className="landing-tile landing-tile-maps h-100 w-100">
              <span className="landing-tile-icon mb-1"><i className="fa fa-map-location-dot"></i></span>
              <span className="landing-tile-title">Maps</span>
              <div className="landing-tile-links">
                <Link to={reportIds['LDC Zone Map'] ? `/report/${reportIds['LDC Zone Map']}` : '#'} className="landing-link-row">
                  <span className="landing-link-icon"><i className="fa fa-layer-group mr-1"></i></span>
                  <span className="landing-link-text">LDC Zone Map</span>
                </Link>
                <Link to={reportIds['FSA Map'] ? `/report/${reportIds['FSA Map']}` : '#'} className="landing-link-row">
                  <span className="landing-link-icon"><i className="fa fa-location-dot mr-1"></i></span>
                  <span className="landing-link-text">FSA Map</span>
                </Link>
                <Link to={reportIds['FSA EV'] ? `/report/${reportIds['FSA EV']}` : '#'} className="landing-link-row">
                  <span className="landing-link-icon"><i className="fa fa-battery-full mr-1"></i></span>
                  <span className="landing-link-text">FSA EV Map</span>
                </Link>
                <Link to={reportIds['Net Meter Map'] ? `/report/${reportIds['Net Meter Map']}` : '#'} className="landing-link-row">
                  <span className="landing-link-icon"><i className="fa fa-bolt mr-1"></i></span>
                  <span className="landing-link-text">Net Meter Map</span>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-6 col-lg-4 mb-3">
            <div className="landing-tile landing-tile-ops h-100 w-100">
              <span className="landing-tile-icon mb-1"><i className="fa fa-chart-line"></i></span>
              <span className="landing-tile-title">Operations</span>
              <div className="landing-tile-links">
                <Link to={reportIds['MDMR Dashboard Reports'] ? `/report/${reportIds['MDMR Dashboard Reports']}` : '#'} className="landing-link-row">
                  <span className="landing-link-icon"><i className="fa fa-tachometer-alt mr-1"></i></span>
                  <span className="landing-link-text">Operations Overview</span>
                </Link>
                <Link to={reportIds['FSA Time Series'] ? `/report/${reportIds['FSA Time Series']}` : '#'} className="landing-link-row">
                  <span className="landing-link-icon"><i className="fa fa-chart-area mr-1"></i></span>
                  <span className="landing-link-text">FSA Time Series</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomePage;
